import React from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import { IconButton, InputLabel } from '@mui/material';
import { Box } from '@mui/system';
import { FormikProps } from 'formik';

import { TextFieldVariants } from '../../../../../../helpers/Constants';
import { serverToday } from '../../../../../../helpers/Functions';
import useBroadcastSchedule from '../../../../../../hooks/Admin/BroadcastList/useBroadcastSchedule';
import CustomDatePicker from '../../../../../common/CustomDatePicker';
import CustomTimePicker from '../../../../../common/CustomTimePicker';
import strings from '../../../../../../localization';

import { IBroadcastScheduleValues } from './helper';
import styles from '../../styles';

const { filled } = TextFieldVariants;

interface IBroadcastScheduleFields<T extends IBroadcastScheduleValues> {
  formik: FormikProps<T>;
}

// DATE AND TIME SHARE ONE ROW UNDER A SINGLE LABEL, LIKE THE OTHER HORIZONTAL FIELDS
const BroadcastScheduleFields = <T extends IBroadcastScheduleValues>({
  formik,
}: IBroadcastScheduleFields<T>) => {
  const { isScheduled, handleClearSchedule } = useBroadcastSchedule(formik);

  return (
    <Box sx={styles.scheduleContainer}>
      <InputLabel sx={styles.scheduleLabel}>{strings.scheduledDate}</InputLabel>
      <Box sx={styles.schedulePickers}>
        <CustomDatePicker
          label=""
          name="sendAtDate"
          formik={formik}
          minDate={serverToday()}
          variant={filled}
          customClass={styles.schedulePicker}
          readOnly
        />
        <CustomTimePicker
          label={null}
          name="sendAtTime"
          formik={formik}
          variant={filled}
          placeholder={strings.selectTime}
          error=" "
          customClass={styles.schedulePicker}
        />
        <IconButton
          aria-label={strings.clear}
          disabled={!isScheduled}
          onClick={handleClearSchedule}
        >
          <ClearIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default BroadcastScheduleFields;
